import QuestionaryLoading from "./QuestionaryLoading";

export default QuestionaryLoading;
